/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useRef } from "react";
import { Typography, Popover, Button } from "@mui/material";
import axios from "../../../utils/axiosConfig";
import standardAxios from "axios";
import RecordRTC from "recordrtc";
import onWindowReload from "../../../utils/reloadFunction";
import { serverConfig } from "../../../utils/serverConstants";
import { PlayArrow, Stop } from "@mui/icons-material";
import CountdownComponent from "../../VideoTest/CountdownTimer";
import { RecordingConfirmationModal, WarningModal, VideoUploadingModal, VideoProcessingModal } from "../../VideoTest/WarningModal";
import {
  getDeviceConfig,
  stopAllMediaStreams,
  checkMediaDeviceSupport,
  NativeMediaRecorder,
  validateiOSBlob,
} from "../../VideoTest/VideoRecordingConfig";
import { buildRecordingStream, getLiveVideoTrack } from "../../../utils/sharedCamera";
import { acquireMicTrack, releaseSharedMicIfUnused } from "../../../utils/sharedMic";
import { useStyles } from "../../../css/VideoInterviewStyles";
import { canvasToBlob, getPrimaryImageFromStorage, getFaceData, formatRecordingTime, checkAudioQuality } from "./helpers";
import supportedFileExtensions from "./supportedFileExtensions";
import { v1_question_images_link } from "./v1-links";
// import { translationMissingMessage } from "./translationConstants";
import { adminBackendURL } from "../../../utils/constants";

export default (props) => {
  const classes = useStyles();
  const {
    testData,
    questionNo,
    setClearFlag,
    clearFlag,
    examId,
    setCheckFlag,
    examDetail,
    answerStatus,
    setAnswerStatus,
    _marksScored,
    _setMarksScored,
    _totalMarks,
    _setTotalMarks,
    _wrongAnswerCount,
    _setWrongAnswerCount,
    _disable,
    setDisable,
    setTestData,
    windowSwitchCount,
    setWindowSwitch,
    isRecording,
    setIsRecording,
    _isVideoSent,
    setIsVideoSent,
    _isVideoUploading,
    setIsVideoUploading,
    isTimeUp,
    _setIsTimeUp,
    facialDataArray,
    setFacialDataArray,
    _isRecordingDone,
    setIsRecordingDone,
    startRecordingCountdown,
    setStartRecordingCountdown,
    recordingVideoRef: sharedRecordingVideoRef,
    sharedCameraStreamRef,
    recordingOnSharedCameraRef,
  } = props;

  const [noVideoUploaded, setNoVideoUploaded] = useState(false);
  const [_selectAnswer, setAnswer] = React.useState("");
  const [recordVideo, setRecordVideo] = React.useState(null);
  const [blobUrl, setBlobUrl] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [_isVideoRecorded, setIsVideoRecorded] = useState(false);
  const [_uploadedVideoLink, setUploadedVideoLink] = useState("");
  const [_uploadingStatus, setUploadingStatus] = React.useState({});
  const [checkArray, setCheckArray] = React.useState(testData[questionNo - 1].selectedChoiceId);
  const [recordingTime, setRecordingTime] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [_recordedTime, setRecordedTime] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [_stopRecordingClicked, setStopRecordingClicked] = useState(false);
  const [userImg, setUserImg] = useState("");
  const [modalType, setModalType] = useState("");
  const [isStartButtonDisabled, setIsStartButtonDisabled] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [_faceProctorInterval, setFaceProctorInterval] = useState(null);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [faceProctorIntervalId, setFaceProctorIntervalId] = useState(null);
  const [recordingBlob, setRecordingBlob] = useState(null);
  const [skipUpload, setSkipUpload] = useState(false);
  const [deviceConfig, setDeviceConfig] = useState(null);
  const [isProcessingVideo, setIsProcessingVideo] = useState(false);
  const [_myOptions, setMyOptions] = React.useState(
    testData[questionNo - 1].selectedChoiceId.match(/\d+/g) ? testData[questionNo - 1].choiceid.replace("|^^|", ",") : ""
  );
  const [isRefreshingUrl, setIsRefreshingUrl] = useState(false);
  const [faceCheckStatus, setFaceCheckStatus] = useState({
    inProgress: false,
    lastResult: null,
    lastCheckTime: null,
  });
  const [_isCheckingAudio, setIsCheckingAudio] = useState(false);
  const [stream, setStream] = useState(null);

  const timerIntervalRef = useRef(null);
  const localVideoRef = useRef(null);
  // Shared with ImageProctoring so it can borrow live frames from this recording
  // instead of racing it for a second camera stream (see ImageProctoring.jsx saveImage()).
  const userVideoRef = sharedRecordingVideoRef || localVideoRef;

  useEffect(() => {
    const config = getDeviceConfig();
    setDeviceConfig(config);
    console.log("Device configuration loaded:", config);
  }, []);

  // useEffect to validate test data when reaching the last question
  useEffect(() => {
    if (questionNo === testData.length) {
      const validateTestData = async () => {
        try {
          const response = await axios.post("/test/validateVideoTestData", {
            userId: examDetail[0].userid,
            userExamId: examId,
            qid: testData[questionNo - 1].qid,
            curQues: questionNo,
          });

          const { updatedTestData, examDetail: updatedExamDetail, updatedQuestions, totalQuestions } = response.data;

          // Decode the response data
          const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(updatedTestData)));
          const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

          const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(updatedExamDetail)));
          const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

          // Update local state
          setTestData({
            ...testData,
            quesData: decodedUpdatedTestData,
            examDetail: decodedUpdatedExamDetail,
          });

          // Update localStorage
          const collectData = {
            quesData: decodedUpdatedTestData,
            examDetail: decodedUpdatedExamDetail,
          };
          const encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))));
          window.localStorage.setItem(examId, encode);

          console.log(`Validated test data: ${updatedQuestions} questions updated out of ${totalQuestions}`);
        } catch (error) {
          console.error("Error validating test data:", error);
        }
      };

      validateTestData();
    }
  }, [questionNo, testData.length, examId, examDetail, setTestData]);

  useEffect(() => {
    if (isRecording && userVideoRef.current && stream) {
      userVideoRef.current.srcObject = stream;
      if (deviceConfig?.deviceType === "iOS") {
        userVideoRef.current.playsInline = true;
        userVideoRef.current.muted = true;
        userVideoRef.current.setAttribute("playsinline", "true");
        userVideoRef.current.setAttribute("webkit-playsinline", "true");
      }
      userVideoRef.current.play().catch((e) => console.error("Error playing video stream:", e));
    }
  }, [isRecording, stream, deviceConfig]);

  useEffect(() => {
    return () => {
      if (stream) {
        console.log("Component unmounting, cleaning up stream");
        stopAllMediaStreams(stream, deviceConfig);
        releaseSharedMicIfUnused();
      }
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const checkAndRefreshVideoUrl = async () => {
      if (!isRecording && testData[questionNo - 1].answerResourcePath && !isRefreshingUrl && !recordingBlob) {
        const videoUrl = testData[questionNo - 1].answerResourcePath;

        if (videoUrl.includes("?") && videoUrl.includes("se=")) {
          try {
            const url = new URL(videoUrl);
            const expiryParam = url.searchParams.get("se");

            if (expiryParam) {
              const expiryDate = new Date(expiryParam);
              const now = new Date();
              const hoursUntilExpiry = (expiryDate - now) / (1000 * 60 * 60);

              if (hoursUntilExpiry <= 24) {
                console.log(`Video URL expiring soon (${hoursUntilExpiry.toFixed(2)} hours left), refreshing...`);
                setIsRefreshingUrl(true);

                const response = await axios.post("/test/validateAndRefreshSASUrls", {
                  userExamId: examId,
                });

                if (response.data.urlsRefreshed) {
                  const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
                  const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

                  const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
                  const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

                  setTestData({
                    ...testData,
                    quesData: decodedUpdatedTestData,
                    examDetail: decodedUpdatedExamDetail,
                  });

                  const collectData = {
                    quesData: decodedUpdatedTestData,
                    examDetail: decodedUpdatedExamDetail,
                  };
                  const encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))));
                  window.localStorage.setItem(examId, encode);

                  console.log("Video URL refreshed successfully");
                } else {
                  console.log("Video URL still valid, no refresh needed");
                }

                setIsRefreshingUrl(false);
              }
            }
          } catch (error) {
            console.error("Error checking/refreshing video URL:", error);
            setIsRefreshingUrl(false);
          }
        } else if (!videoUrl.includes("?")) {
          console.log("Old public URL detected, converting to SAS URL...");
          setIsRefreshingUrl(true);

          try {
            const response = await axios.post("/test/validateAndRefreshSASUrls", {
              userExamId: examId,
            });

            const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
            const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

            const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
            const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

            setTestData({
              ...testData,
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            });

            const collectData = {
              quesData: decodedUpdatedTestData,
              examDetail: decodedUpdatedExamDetail,
            };
            const encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))));
            window.localStorage.setItem(examId, encode);

            console.log("Converted public URL to SAS URL successfully");
          } catch (error) {
            console.error("Error converting to SAS URL:", error);
          }

          setIsRefreshingUrl(false);
        }
      }
    };

    checkAndRefreshVideoUrl();
  }, [questionNo, isRecording, testData, examId, isRefreshingUrl, recordingBlob]);

  useEffect(() => {
    if (!isRecording) {
      setFacialDataArray([]);
    }
  }, [isRecording]);

  React.useEffect(() => {
    if (isRecording) {
      setShowModal(false);
      setModalType("");
      setSkipUpload(false);
      setNoVideoUploaded(false);
      setShowUploadModal(false);
    }
  }, [isRecording]);

  useEffect(() => {
    if (!faceCheckStatus.inProgress && faceCheckStatus.lastResult === false && isRecording) {
      const retryTimeout = setTimeout(() => {
        setFaceCheckStatus((prev) => ({
          ...prev,
          inProgress: false,
        }));
      }, 3000);
      return () => clearTimeout(retryTimeout);
    }
  }, [faceCheckStatus, isRecording]);

  React.useEffect(() => {
    if (noVideoUploaded) {
      stopRecording();
      setIsRecordingDone(true);
      setShowModal(true);
    }
  }, [noVideoUploaded]);

  const getVideoSrc = () => {
    if (recordingBlob && blobUrl) {
      return blobUrl;
    }

    if (isRefreshingUrl) {
      return "";
    }

    if (testData[questionNo - 1].answerResourcePath) {
      return testData[questionNo - 1].answerResourcePath;
    }

    // Only return Azure URL if answerResourceName exists and is valid
    if (testData[questionNo - 1].answerResourceName) {
      return `${serverConfig.azureStorageURL}${testData[questionNo - 1].answerResourceName}`;
    }

    // No valid video source
    return "";
  };

  const startRecordingWithConfirmation = () => {
    setShowConfirmation(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setNoVideoUploaded(false);
    setIsStartButtonDisabled(false);
    setSkipUpload(false);
  };

  const handleRetryRecording = () => {
    setShowModal(false);
    setModalType("");
    setNoVideoUploaded(false);
    setIsStartButtonDisabled(false);
    setSkipUpload(false);
    setBlobUrl("");
    setRecordingBlob(null);
    setIsVideoSent(false);
    setRecordingTime(0);
    setUploadingStatus((prev) => ({
      ...prev,
      [questionNo]: { uploading: false, success: false },
    }));
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  onWindowReload(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, testData);

  const open = Boolean(anchorEl);

  const getAnswer = (_values) => {
    if (testData[questionNo - 1].selectedChoiceId.match(/\d+/g)) {
      if (testData[questionNo - 1].selectedChoiceId.indexOf("null") === -1) {
        testData[questionNo - 1].buttonStyle = "Answered";
      }
    }
  };

  const getBrowserName = (userAgent) => {
    if (/Chrome/i.test(userAgent) && !/CriOS/i.test(userAgent)) return "Chrome";
    if (/CriOS/i.test(userAgent)) return "Chrome";
    if (/Firefox/i.test(userAgent) || /FxiOS/i.test(userAgent)) return "Firefox";
    if (/Edg/i.test(userAgent) || /EdgiOS/i.test(userAgent)) return "Edge";
    if (/Safari/i.test(userAgent) && !/Chrome|CriOS|Edg|EdgiOS|FxiOS|Firefox/i.test(userAgent)) return "Safari";
    return "Unknown";
  };

  const getPlatformInfo = async () => {
    const userAgent = navigator.userAgent;
    if (/Win/i.test(userAgent)) return "Windows";
    if (/Mac/i.test(userAgent)) return "macOS";
    if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
    if (/Android/i.test(userAgent)) return "Android";
    return "Unknown";
  };

  const logVideoEvent = async (status, error = null, additionalLogs = {}) => {
    try {
      const platform = await getPlatformInfo();
      const userAgent = navigator.userAgent;
      const browser = getBrowserName(userAgent);
      const deviceType = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(userAgent) ? "mobile" : "desktop";
      const logData = {
        examId: props.examId,
        questionNo: questionNo,
        userId: examDetail[0].userid,
        status,
        errorName: error ? error.name : null,
        errorMessage: error ? error.message : null,
        errorStack: error ? error.stack : null,
        userAgent,
        platform,
        deviceType,
        browser,
        additionalLogs,
      };

      await standardAxios
        .post(`${adminBackendURL}/api/mobile-testing/videoLogs`, logData)
        .then((res) => console.log("Video log sent:", res.data))
        .catch((err) => console.error("Error sending video log:", err));
    } catch (logError) {
      console.error("Error preparing video log:", logError);
    }
  };

  const startRecording = async () => {
    try {
      if (!deviceConfig) {
        console.error("Device configuration not loaded");
        return;
      }

      setFacialDataArray([]);
      setSkipUpload(false);
      setNoVideoUploaded(false);
      setShowModal(false);
      setModalType("");
      setRecordingTime(0);

      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }

      const mediaSupport = await checkMediaDeviceSupport();
      if (!mediaSupport.hasVideoInput || !mediaSupport.hasAudioInput) {
        setModalType("noMediaDevice");
        setShowModal(true);
        return;
      }

      // Record from the exam's shared camera (ImageProctoring's stream) plus the microphone,
      // instead of opening the camera a second time - see utils/sharedCamera.js. Falls back to
      // opening the camera here when there is no shared stream (image proctoring off) or
      // combining the two fails.
      let mediaStream = null;
      let onSharedCamera = false;
      const sharedStream = sharedCameraStreamRef && sharedCameraStreamRef.current;
      if (getLiveVideoTrack(sharedStream)) {
        try {
          mediaStream = await buildRecordingStream(sharedStream, deviceConfig.mediaConstraints);
          onSharedCamera = true;
        } catch (sharedErr) {
          console.warn("Recording from the shared camera failed, opening the camera directly:", sharedErr && sharedErr.name, sharedErr && sharedErr.message);
        }
      }
      if (!mediaStream) {
        // Camera only here; the sound is a copy of the exam's one microphone capture
        // (utils/sharedMic.js) - a second microphone capture mutes the first on phones.
        const cameraStream = await navigator.mediaDevices.getUserMedia({ ...deviceConfig.mediaConstraints, audio: false });
        try {
          mediaStream = new MediaStream([...cameraStream.getVideoTracks(), await acquireMicTrack()]);
        } catch (micErr) {
          cameraStream.getTracks().forEach((track) => track.stop());
          throw micErr;
        }
      }
      if (recordingOnSharedCameraRef) recordingOnSharedCameraRef.current = onSharedCamera;
      console.log("Media stream obtained:", mediaStream.id, "Active tracks:", mediaStream.getTracks().length, "shared camera:", onSharedCamera);
      setStream(mediaStream);

      let mediaRecorder;

      if (deviceConfig.useNativeRecorder) {
        console.log("Using NativeMediaRecorder for iOS");
        mediaRecorder = new NativeMediaRecorder(mediaStream, deviceConfig.nativeRecorderOptions);
      } else {
        console.log("Using RecordRTC for non-iOS devices");
        mediaRecorder = new RecordRTC(mediaStream, deviceConfig.recordRTCOptions);
      }

      mediaRecorder.startRecording();
      console.log("Recording started successfully");

      setRecordVideo(mediaRecorder);
      setIsRecording(true);
      setIsVideoSent(true);
      setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: false } }));

      // Start recording timer immediately - don't wait for image upload
      const startTime = Date.now();
      console.log("Starting recording timer at:", startTime);

      timerIntervalRef.current = setInterval(() => {
        const currentTime = Date.now();
        const elapsedSeconds = Math.floor((currentTime - startTime) / 1000);

        if (elapsedSeconds >= 241) {
          console.log("Max recording time reached (241 seconds)");
          if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
          }
        } else {
          setRecordingTime(elapsedSeconds);
        }
      }, 1000);

      await logVideoEvent("success", null, {
        action: "startRecording",
        message: "Started video recording",
        deviceType: deviceConfig.deviceType,
        useNativeRecorder: deviceConfig.useNativeRecorder,
        mediaConstraints: deviceConfig.mediaConstraints,
        sharedCamera: onSharedCamera,
      });

      const videoElement = document.createElement("video");
      videoElement.srcObject = mediaStream;
      videoElement.muted = true;

      if (deviceConfig.deviceType === "iOS") {
        videoElement.playsInline = true;
        videoElement.setAttribute("playsinline", "true");
      }

      videoElement.play();

      await new Promise((resolve) => {
        if (videoElement.readyState >= 2) {
          resolve();
        } else {
          videoElement.onloadedmetadata = () => resolve();
        }
      });

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      let imageBlob = null;

      // A live stream's next real frame shows up within a render tick or two (tens of ms), so
      // this only needs to cover a normal camera warm-up, not act as a real recovery mechanism.
      const THUMBNAIL_BLACK_FRAME_MAX_RETRIES = 5;
      const THUMBNAIL_BLACK_FRAME_RETRY_INTERVAL_MS = 200;
      for (let attempt = 0; attempt < THUMBNAIL_BLACK_FRAME_MAX_RETRIES; attempt++) {
        if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          ctx.drawImage(videoElement, 0, 0);

          const sample = ctx.getImageData(0, 0, Math.min(30, canvas.width), Math.min(30, canvas.height)).data;
          let hasContent = false;
          for (let i = 0; i < sample.length; i += 4) {
            if (sample[i] > 10 || sample[i + 1] > 10 || sample[i + 2] > 10) {
              hasContent = true;
              break;
            }
          }

          if (hasContent || attempt === THUMBNAIL_BLACK_FRAME_MAX_RETRIES - 1) {
            imageBlob = await canvasToBlob(canvas);
            if (hasContent) {
              console.log(`Successfully captured non-black frame on attempt ${attempt + 1} for video interview question with id ${props.testData[props.questionNo - 1].qid}`);
              break;
            } else {
              console.log(`Camera feed still black after ${THUMBNAIL_BLACK_FRAME_MAX_RETRIES} retries for video interview question with id ${props.testData[props.questionNo - 1].qid}, proceeding to save last available frame`);
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, THUMBNAIL_BLACK_FRAME_RETRY_INTERVAL_MS));
      }

      try {
        videoElement.pause();
        videoElement.srcObject = null;
      } catch (e) {
        // ignore cleanup error
      }
      const imageName = `${props.examDetail[0].userid}_${props.examId}_${props.testData[props.questionNo - 1].qid}.jpg`;

      const formData = new FormData();
      formData.append("file", imageBlob, imageName);

      try {
        const response = await axios.post("/test/uploadImg", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setUserImg(response.data.imageUrl);
      } catch (error) {
        console.error("Error uploading image:", error);
        await logVideoEvent("failure", error, { action: "uploadImage", message: "Failed to upload image" });
      }
      // Timer already started above - no need to start it again here
    } catch (error) {
      console.error("Error starting recording:", error);
      if (recordingOnSharedCameraRef) recordingOnSharedCameraRef.current = false;
      // Previously only logged, so the candidate saw nothing when the camera or microphone
      // couldn't be opened and recording simply never started.
      if (error && ["NotAllowedError", "NotFoundError", "NotReadableError", "OverconstrainedError", "AbortError"].includes(error.name)) {
        setModalType("noMediaDevice");
        setShowModal(true);
      }
      await logVideoEvent("failure", error, {
        action: "startRecording",
        message: "Failed to start video recording",
        deviceType: deviceConfig ? deviceConfig.deviceType : "unknown",
        useNativeRecorder: deviceConfig ? deviceConfig.useNativeRecorder : false,
      });
    }
  };

  const uploadVideo = async (blob, filename, currentRecordingTime) => {
    if (skipUpload) {
      setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: false } }));
      setIsVideoSent(false);
      await logVideoEvent("failure", null, { action: "uploadVideo", message: "Upload skipped due to previous error" });
      return;
    }

    if (!facialDataArray || facialDataArray.length === 0) {
      setSkipUpload(true);
      setNoVideoUploaded(true);
      setModalType("noFacialData");
      setShowModal(true);
      setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: false } }));
      setIsVideoSent(false);
      await logVideoEvent("failure", null, { action: "uploadVideo", message: "No facial data detected", recordingSeconds: currentRecordingTime });
      return;
    }

    const formData = new FormData();
    formData.append("video", blob, filename);

    let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(examDetail))));
    let encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(testData))));

    formData.append("examId", examId);
    formData.append("questionNo", questionNo.toString());
    formData.append("recordedTime", currentRecordingTime);
    formData.append("userImage", userImg);
    formData.append("facialData", JSON.stringify(facialDataArray));
    formData.append("examDetail", encodedExamDetail);
    formData.append("testData", encodedQuesData);
    formData.append("windowSwitchCount", windowSwitchCount.toString());

    setUploadProgress(0);
    setIsVideoUploading(true);
    setShowUploadModal(true);

    try {
      const response = await axios({
        method: "POST",
        url: "/test/uploadvideo",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (event) => {
          if (event.lengthComputable) {
            setUploadProgress(Math.round((event.loaded / event.total) * 100));
          }
        },
      });

      const {
        videoUrl,
        file_name,
        file_size,
        updatedTestData: encodedUpdatedTestData,
        examDetail: encodedUpdatedExamDetail,
      } = response.data;

      let decodedUpdatedTestData, decodedUpdatedExamDetail;
      try {
        decodedUpdatedTestData = JSON.parse(decodeURIComponent(atob(decodeURIComponent(encodedUpdatedTestData))));
        decodedUpdatedExamDetail = JSON.parse(decodeURIComponent(atob(decodeURIComponent(encodedUpdatedExamDetail))));
      } catch (decodeError) {
        console.error("Error decoding response data:", decodeError);
        setIsVideoUploading(false);
        setShowUploadModal(false);
        setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: false } }));
        setIsVideoSent(false);
        setModalType("databaseError");
        setShowModal(true);
        await logVideoEvent("failure", decodeError, { action: "uploadVideo", message: "Failed to decode response data" });
        return;
      }

      const updatedQuestion = decodedUpdatedTestData[questionNo - 1];
      const localUpdatedTestData = [...testData];
      localUpdatedTestData[questionNo - 1] = { ...localUpdatedTestData[questionNo - 1], ...updatedQuestion, mongoSaved: true };

      setTestData({ ...testData, quesData: decodedUpdatedTestData, examDetail: decodedUpdatedExamDetail || examDetail });

      const collectData = { quesData: decodedUpdatedTestData, examDetail: decodedUpdatedExamDetail || examDetail };
      window.localStorage.setItem(examId, encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData)))));

      setFacialDataArray([]);
      setUploadedVideoLink(videoUrl);
      setIsVideoUploading(false);
      setUploadProgress(0);
      setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: true } }));
      setIsVideoRecorded(true);
      setIsVideoSent(false);
      setCheckFlag(true);
      setRecordingTime(0);
      setIsRecordingDone(true);
      setShowUploadModal(false);

      await logVideoEvent("success", null, {
        action: "uploadVideo",
        message: "Video uploaded successfully",
        fileName: file_name,
        fileSize: file_size,
        videoUrl,
      });
    } catch (error) {
      console.error("Error uploading video file:", error);
      setIsVideoUploading(false);
      setShowUploadModal(false);
      setUploadProgress(0);
      setUploadingStatus((prev) => ({ ...prev, [questionNo]: { uploading: false, success: false } }));
      setIsVideoSent(false);
      setNoVideoUploaded(true);

      if (error.response && error.response.data && error.response.data.error === "Database update failed") {
        setModalType("databaseError");
        await logVideoEvent("failure", error, { action: "uploadVideo", message: "Database update failed" });
      } else {
        setModalType("corruptVideo");
        await logVideoEvent("failure", error, { action: "uploadVideo", message: "Failed to upload video file" });
      }
      setShowModal(true);
    }
  };

  const stopRecording = async () => {
    // Taken before the streams are stopped, for the stop log below.
    const micAtStop = stream && stream.getAudioTracks()[0];
    const recordingSnapshot = {
      sharedCamera: !!(recordingOnSharedCameraRef && recordingOnSharedCameraRef.current),
      micTrack: micAtStop ? { state: micAtStop.readyState, muted: micAtStop.muted } : null,
    };
    setFaceCheckStatus({ inProgress: false, lastResult: null, lastCheckTime: null });
    clearInterval(faceProctorIntervalId);

    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }

    if (recordVideo) {
      setUploadingStatus((prev) => ({
        ...prev,
        [questionNo]: { uploading: true, success: false },
      }));

      setIsProcessingVideo(true);
      setIsVideoUploading(true);  // Pause proctoring during video processing and upload

      recordVideo.stopRecording(async () => {
        try {
          let blob = recordVideo.getBlob();

          if (deviceConfig.useNativeRecorder && deviceConfig.deviceType === "iOS") {
            try {
              blob = await validateiOSBlob(blob, recordVideo.getBlob);
            } catch (blobError) {
              console.error("iOS blob validation failed:", blobError);
              setNoVideoUploaded(true);
              setModalType("corruptVideo");
              setShowModal(true);
              setUploadingStatus((prev) => ({
                ...prev,
                [questionNo]: { uploading: false, success: false },
              }));
              setIsVideoSent(false);
              setIsProcessingVideo(false);
              setIsVideoUploading(false);
              await logVideoEvent("failure", blobError, {
                action: "stopRecording",
                message: "iOS blob validation failed",
                blobSize: blob ? blob.size : 0,
                deviceType: deviceConfig.deviceType,
              });
              return;
            }
          } else if (!blob || blob.size === 0) {
            console.error("Empty or invalid video blob detected");
            setNoVideoUploaded(true);
            setModalType("corruptVideo");
            setShowModal(true);
            setUploadingStatus((prev) => ({
              ...prev,
              [questionNo]: { uploading: false, success: false },
            }));
            setIsVideoSent(false);
            setIsProcessingVideo(false);
            setIsVideoUploading(false);
            await logVideoEvent("failure", null, {
              action: "stopRecording",
              message: "Empty video blob",
              blobSize: blob ? blob.size : 0,
              deviceType: deviceConfig.deviceType,
            });
            return;
          }

          if (stream) {
            // On the shared camera these are the recording's own clone and microphone tracks;
            // the proctoring camera itself keeps running.
            stopAllMediaStreams(stream, deviceConfig);
            releaseSharedMicIfUnused();
            if (userVideoRef.current) {
              userVideoRef.current.srcObject = null;
              userVideoRef.current.src = "";
              if (deviceConfig && deviceConfig.deviceType === "iOS") {
                userVideoRef.current.load();
              }
            }
          }

          const url = URL.createObjectURL(blob);
          const currentRecordingTime = formatRecordingTime(recordingTime);

          setRecordedTime(currentRecordingTime);
          setBlobUrl(url);
          setIsRecording(false);
          if (recordingOnSharedCameraRef) recordingOnSharedCameraRef.current = false;
          setRecordingBlob(blob);

          const filename = `${props.examDetail[0].userid}_${props.examId}_${testData[questionNo - 1].qid}.mp4`;

          await logVideoEvent("success", null, {
            action: "stopRecording",
            message: "Stopped video recording successfully",
            fileSize: blob.size,
            recordingSeconds: recordingTime,
            faceChecksDuringRecording: facialDataArray ? facialDataArray.length : 0,
            ...recordingSnapshot,
            deviceType: deviceConfig.deviceType,
            useNativeRecorder: deviceConfig.useNativeRecorder,
            blobType: blob.type,
          });

          if (skipUpload) {
            setUploadingStatus((prev) => ({
              ...prev,
              [questionNo]: { uploading: false, success: false },
            }));
            setIsVideoSent(false);
            if (!showModal) {
              setShowModal(true);
            }
            setIsProcessingVideo(false);
            setIsVideoUploading(false);
            await logVideoEvent("failure", null, {
              action: "stopRecording",
              message: "Upload skipped due to previous error",
            });
            return;
          }

          try {
            if (userVideoRef.current && blob) {
              const canvas = document.createElement("canvas");
              canvas.width = userVideoRef.current.videoWidth || 640;
              canvas.height = userVideoRef.current.videoHeight || 480;

              if (deviceConfig.deviceType === "iOS") {
                const tempVideo = document.createElement("video");
                tempVideo.src = url;
                tempVideo.playsInline = true;
                tempVideo.muted = true;

                await new Promise((resolve, reject) => {
                  tempVideo.onloadedmetadata = () => {
                    try {
                      canvas.width = tempVideo.videoWidth || 640;
                      canvas.height = tempVideo.videoHeight || 480;
                      canvas.getContext("2d").drawImage(tempVideo, 0, 0);
                      resolve();
                    } catch (error) {
                      console.error("Error drawing iOS video to canvas:", error);
                      reject(error);
                    }
                  };
                  tempVideo.onerror = reject;
                });
              } else {
                canvas.getContext("2d").drawImage(userVideoRef.current, 0, 0);
              }

              const finalImageBlob = await canvasToBlob(canvas);
              const primaryImage = getPrimaryImageFromStorage();

              if (primaryImage) {
                const finalFaceResult = await getFaceData(finalImageBlob, primaryImage);

                if (!finalFaceResult.success || !finalFaceResult.facevisible || finalFaceResult.numfaces === 0) {
                  setSkipUpload(true);
                  setNoVideoUploaded(true);
                  setModalType("faceNotDetected");
                  setShowModal(true);
                  setUploadingStatus((prev) => ({
                    ...prev,
                    [questionNo]: { uploading: false, success: false },
                  }));
                  setIsVideoSent(false);
                  setIsProcessingVideo(false);
                  setIsVideoUploading(false);
                  await logVideoEvent("failure", null, {
                    action: "faceVerification",
                    message: "Face not detected",
                  });
                  return;
                } else if (finalFaceResult.numfaces >= 2) {
                  setSkipUpload(true);
                  setNoVideoUploaded(true);
                  setModalType("multipleFaces");
                  setShowModal(true);
                  setUploadingStatus((prev) => ({
                    ...prev,
                    [questionNo]: { uploading: false, success: false },
                  }));
                  setIsVideoSent(false);
                  setIsProcessingVideo(false);
                  setIsVideoUploading(false);
                  await logVideoEvent("failure", null, {
                    action: "faceVerification",
                    message: "Multiple faces detected",
                  });
                  return;
                } else if (
                  finalFaceResult.facematchresult &&
                  (!finalFaceResult.facematchresult.verified || finalFaceResult.facematchresult.similarityscore < 15)
                ) {
                  setSkipUpload(true);
                  setNoVideoUploaded(true);
                  setModalType("faceNotMatching");
                  setShowModal(true);
                  setUploadingStatus((prev) => ({
                    ...prev,
                    [questionNo]: { uploading: false, success: false },
                  }));
                  setIsVideoSent(false);
                  setIsProcessingVideo(false);
                  setIsVideoUploading(false);
                  await logVideoEvent("failure", null, {
                    action: "faceVerification",
                    message: "Face not matching",
                  });
                  return;
                }
              }
            }
          } catch (error) {
            console.error("Error in final face verification:", error);
            setIsProcessingVideo(false);
            setIsVideoUploading(false);
            await logVideoEvent("failure", error, {
              action: "faceVerification",
              message: "Error in face verification",
            });
          }

          if (recordingTime < 30) {
            setModalType("shortDuration");
            setShowModal(true);
            setUploadingStatus((prev) => ({
              ...prev,
              [questionNo]: { uploading: false, success: false },
            }));
            setIsVideoSent(false);
            setIsProcessingVideo(false);
            setIsVideoUploading(false);
            await logVideoEvent("failure", null, {
              action: "stopRecording",
              message: "Recording duration too short",
            });
            return;
          }

          setIsStartButtonDisabled(true);
          setIsCheckingAudio(true);

          try {
            const audioQualityResult = await checkAudioQuality(blob, async () => {
              setModalType("noAudio");
              setShowModal(true);
              setIsProcessingVideo(false);
              setIsVideoUploading(false);
              await logVideoEvent("failure", null, {
                action: "audioQualityCheck",
                message: "No audio detected in video",
              });
            });

            setIsCheckingAudio(false);

            if (audioQualityResult === "good_audio") {
              setIsProcessingVideo(false);
              await uploadVideo(blob, filename, currentRecordingTime);
            }
          } catch (audioError) {
            console.error("Error checking audio quality:", audioError);
            setIsCheckingAudio(false);
            setIsProcessingVideo(false);
            setIsVideoUploading(false);
            await logVideoEvent("failure", audioError, {
              action: "audioQualityCheck",
              message: "Error checking audio quality",
            });
          }
        } catch (error) {
          console.error("Error in stopRecording callback:", error);
          setUploadingStatus((prev) => ({
            ...prev,
            [questionNo]: { uploading: false, success: false },
          }));
          setIsVideoSent(false);
          setNoVideoUploaded(true);
          setModalType("corruptVideo");
          setShowModal(true);
          setIsProcessingVideo(false);
          setIsVideoUploading(false);
          await logVideoEvent("failure", error, {
            action: "stopRecording",
            message: "Error in stopRecording callback",
            deviceType: deviceConfig.deviceType,
            useNativeRecorder: deviceConfig.useNativeRecorder,
          });
        }
      });
    }
  };

  React.useEffect(() => {
    if (isTimeUp && isRecording && recordingTime >= 30) {
      stopRecording();
    } else if (isTimeUp && isRecording && recordingTime < 30) {
      setIsRecordingDone(true);
    } else if (isTimeUp && !isRecording) {
      setIsRecordingDone(true);
    }
  }, [isTimeUp, recordingTime]);

  React.useEffect(() => {
    if (recordingTime >= 240) {
      console.log("Maximum recording time reached");
      stopRecording();
    }
  }, [recordingTime]);

  React.useEffect(() => {
    if (skipUpload && !showModal && (modalType === "faceNotDetected" || modalType === "faceNotMatching")) {
      setShowModal(true);
    }
  }, [skipUpload, modalType]);

  const playRecordedVideo = () => {
    if (blobUrl) {
      const video = document.getElementById("recordedVideo");
      video.src = blobUrl;
      video.play();
    }
  };

  const handleRecordingButton = () => {
    setStopRecordingClicked(true);
    if (isRecording) {
      stopRecording()
        .then(() => {
          setStopRecordingClicked(false);
        })
        .catch((error) => {
          console.error("Error in handleRecordingButton:", error);
          setStopRecordingClicked(false);
          setModalType("corruptVideo");
          setShowModal(true);
          setUploadingStatus((prev) => ({
            ...prev,
            [questionNo]: { uploading: false, success: false },
          }));
          setIsVideoSent(false);
        });
    } else if (blobUrl) {
      playRecordedVideo();
      setStopRecordingClicked(false);
    } else {
      startRecording();
      setStopRecordingClicked(false);
    }
  };

  React.useEffect(() => {
    setIsRecordingDone(false);
    setUserImg("");
    setIsStartButtonDisabled(false);
    setIsVideoUploading(false);
    if (questionNo === testData.length) {
      setDisable(true);
    }
    if (clearFlag) {
      setAnswer("");
      setMyOptions("");
      setCheckArray("");
      let temp = answerStatus;
      setAnswerStatus(temp);
      testData[questionNo - 1].buttonStyle = "Not Answered";
      setClearFlag(false);
    }
    setRecordVideo(null);
    setBlobUrl("");
    setRecordingBlob(null);
    setSkipUpload(false);
    setStopRecordingClicked(false);
  }, [clearFlag, questionNo]);

  getAnswer(checkArray);

  return (
    <div>
      <>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <span className="question-num">
            Q .{questionNo} of {testData.length}
          </span>
        </Typography>
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{ paper: classes.paper }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>{testData[questionNo - 1].qid}</Typography>
        </Popover>
        {examDetail[0].selectedLanguage === null ||
          examDetail[0].selectedLanguage === "en-IN" ||
          examDetail[0].include_english === true ||
          (examDetail[0].selectedLanguage !== null && examDetail[0].selectedLanguage !== "en-IN" && testData[questionNo - 1].translated_qtext === null) ? (
          <span
            dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].qtext }}
            style={{ fontWeight: "bold", fontSize: "1.2em", color: "#333" }}
          />
        ) : null}
        {examDetail[0].selectedLanguage !== null &&
          examDetail[0].selectedLanguage !== "en-IN" &&
          (examDetail[0].include_english === true || testData[questionNo - 1].translated_qtext === null) ? (
          <>
            <br />
            <br />
          </>
        ) : null}
        {examDetail[0].selectedLanguage !== null && examDetail[0].selectedLanguage !== "en-IN" ? (
          <span
            dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].translated_qtext || "" }}
            style={{ fontWeight: "bold", fontSize: "1.2em", color: "#333" }}
          />
        ) : null}
        {(testData[questionNo - 1].qresourcepath.split("|^^|")[0] !== undefined &&
          testData[questionNo - 1].qresourcepath.split("|^^|")[0] !== null &&
          testData[questionNo - 1].qresourcepath.split("|^^|")[0] !== "") ||
          (testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
            testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
            testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== "") ? (
          <div>
            {supportedFileExtensions.image.includes(
              testData[questionNo - 1].qresourcepath
                .split("|^^|")[0]
                .split(".")
              [testData[questionNo - 1].qresourcepath.split("|^^|")[0].split(".").length - 1].toLowerCase()
            ) ? (
              <img
                src={
                  testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== ""
                    ? testData[questionNo - 1].question_resource_url.split("|^^|")[0]
                    : v1_question_images_link + testData[questionNo - 1].qresourcepath.split("|^^|")[0]
                }
                key={testData[questionNo - 1].qid}
                style={{ maxWidth: "100%" }}
                alt=""
              />
            ) : supportedFileExtensions.audio.includes(
              testData[questionNo - 1].qresourcepath
                .split("|^^|")[0]
                .split(".")
              [testData[questionNo - 1].qresourcepath.split("|^^|")[0].split(".").length - 1].toLowerCase()
            ) ? (
              <audio
                controls
                src={
                  testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== ""
                    ? testData[questionNo - 1].question_resource_url.split("|^^|")[0]
                    : v1_question_images_link + testData[questionNo - 1].qresourcepath.split("|^^|")[0]
                }
                key={testData[questionNo - 1].qid}
                style={{ maxWidth: "100%" }}
                alt=""
              />
            ) : supportedFileExtensions.video.includes(
              testData[questionNo - 1].qresourcepath
                .split("|^^|")[0]
                .split(".")
              [testData[questionNo - 1].qresourcepath.split("|^^|")[0].split(".").length - 1].toLowerCase()
            ) ? (
              <video
                controls
                src={
                  testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== ""
                    ? testData[questionNo - 1].question_resource_url.split("|^^|")[0]
                    : v1_question_images_link + testData[questionNo - 1].qresourcepath.split("|^^|")[0]
                }
                key={testData[questionNo - 1].qid}
                style={{ maxWidth: "100%" }}
                alt=""
              />
            ) : supportedFileExtensions.file.includes(
              testData[questionNo - 1].qresourcepath
                .split("|^^|")[0]
                .split(".")
              [testData[questionNo - 1].qresourcepath.split("|^^|")[0].split(".").length - 1].toLowerCase()
            ) ? (
              <a
                style={{ color: "#337ab7", fontSize: "16px" }}
                href={
                  testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== undefined &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== null &&
                    testData[questionNo - 1].question_resource_url.split("|^^|")[0] !== ""
                    ? testData[questionNo - 1].question_resource_url.split("|^^|")[0]
                    : v1_question_images_link + testData[questionNo - 1].qresourcepath.split("|^^|")[0]
                }
                download
              >
                CLICK TO DOWNLOAD
              </a>
            ) : null}
            <br />
            <br />
          </div>
        ) : (
          <></>
        )}
        <div className={classes.container}>
          {!isRecording ? (
            <>
              <div className="videodiv">
                {startRecordingCountdown ? (
                  <CountdownComponent
                    isPlaying={startRecordingCountdown}
                    duration={3}
                    onComplete={() => {
                      startRecording();
                      setStartRecordingCountdown(false);
                    }}
                  />
                ) : (
                  <>
                    {isRefreshingUrl ? (
                      <div
                        className={classes.video}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "300px",
                          backgroundColor: "#f0f0f0",
                          marginBottom: "20px",
                        }}
                      >
                        <Typography>Refreshing video link...</Typography>
                      </div>
                    ) : getVideoSrc() ? (
                      <video
                        id="recordedVideo"
                        key={recordingBlob ? 'blob' : testData[questionNo - 1].answerResourcePath || 'empty'}
                        src={getVideoSrc()}
                        controls
                        type="video/mp4"
                        className={classes.video}
                        onError={(e) => {
                          console.error("Video playback error:", e);
                          if (!isRefreshingUrl && testData[questionNo - 1].answerResourcePath) {
                            console.log("Video load failed, attempting to refresh URL...");
                            setIsRefreshingUrl(true);
                            axios
                              .post("/test/validateAndRefreshSASUrls", {
                                userExamId: examId,
                              })
                              .then((response) => {
                                const decodedTestDataString = decodeURIComponent(atob(decodeURIComponent(response.data.updatedTestData)));
                                const decodedUpdatedTestData = JSON.parse(decodedTestDataString);

                                const decodedExamDetailString = decodeURIComponent(atob(decodeURIComponent(response.data.examDetail)));
                                const decodedUpdatedExamDetail = JSON.parse(decodedExamDetailString);

                                setTestData({
                                  ...testData,
                                  quesData: decodedUpdatedTestData,
                                  examDetail: decodedUpdatedExamDetail,
                                });

                                const collectData = {
                                  quesData: decodedUpdatedTestData,
                                  examDetail: decodedUpdatedExamDetail,
                                };
                                const encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))));
                                window.localStorage.setItem(examId, encode);

                                setIsRefreshingUrl(false);
                              })
                              .catch((err) => {
                                console.error("Failed to refresh URL:", err);
                                setIsRefreshingUrl(false);
                              });
                          }
                        }}
                      />
                    ) : (
                      <div
                        className={classes.video}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "300px",
                          backgroundColor: "#f5f5f5",
                          border: "2px dashed #ccc",
                          marginBottom: "20px",
                        }}
                      >
                        <Typography variant="body1" style={{ color: "#666", textAlign: "center" }}>
                          No video recorded yet.<br />Click "Start Recording" to begin.
                        </Typography>
                      </div>
                    )}
                  </>
                )}
              </div>
              {!startRecordingCountdown ? (
                <>
                  {testData[questionNo - 1].answerResourceName || testData[questionNo - 1].disabled ? (
                    <>
                      <div style={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
                        <Typography variant="body2" gutterBottom style={{ margin: "1px", marginRight: "16px" }}>
                          Recorded Time: <b>{testData[questionNo - 1].recordedTime}</b>
                        </Typography>
                      </div>
                      <Typography style={{ color: "#4CAF50", fontSize: "16px", fontWeight: "bold", margin: "0" }}>
                        Video saved successfully !
                      </Typography>
                    </>
                  ) : null}

                  {recordingBlob && skipUpload ? (
                    <Button
                      onClick={handleRetryRecording}
                      className={classes.button}
                      startIcon={<PlayArrow />}
                      size="large"
                      style={{ marginRight: "10px" }}
                    >
                      Retry Recording
                    </Button>
                  ) : null}

                  <Button
                    onClick={startRecordingWithConfirmation}
                    disabled={isStartButtonDisabled || testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled}
                    className={classes.button}
                    startIcon={<PlayArrow />}
                    size="large"
                    style={{
                      backgroundColor:
                        isStartButtonDisabled || testData[questionNo - 1].answerResourcePath || testData[questionNo - 1].disabled
                          ? undefined
                          : "#4CAF50",
                      color: "white",
                    }}
                  >
                    Start Recording
                  </Button>

                  <RecordingConfirmationModal
                    open={showConfirmation}
                    onClose={(confirmed) => {
                      setShowConfirmation(false);
                      if (!confirmed) return;
                      setStartRecordingCountdown(true);
                    }}
                    onConfirm={() => {
                      setShowConfirmation(false);
                      setStartRecordingCountdown(true);
                    }}
                  />

                  <WarningModal open={showModal} onClose={handleCloseModal} modalType={modalType} onRetry={handleRetryRecording} />
                  <VideoUploadingModal open={showUploadModal} progress={uploadProgress} />
                  <VideoProcessingModal open={isProcessingVideo} />
                </>
              ) : null}
            </>
          ) : (
            <div className={classes.container}>
              <div className="videodiv">
                <video
                  id="userVideo"
                  ref={userVideoRef}
                  className={classes.video}
                  playsInline={deviceConfig && deviceConfig.videoPlaysinline}
                  webkit-playsinline={deviceConfig && deviceConfig.deviceType === "iOS" ? "true" : undefined}
                  muted
                />
                <Typography variant="body2" gutterBottom style={{ margin: "1px" }}>
                  Recording Time: <span style={{ color: "#6f2981" }}>{formatRecordingTime(recordingTime)}</span>
                </Typography>
              </div>
              <>
                <p>Click below button to stop recording</p>
                <div>
                  <Button size="large" onClick={handleRecordingButton} className={classes.button} startIcon={<Stop />}>
                    <b>Stop Recording</b>
                  </Button>
                </div>
              </>
            </div>
          )}
        </div>
      </>
    </div>
  );
};
